import { httpAuthRequest, httpRequest } from '@/services'
import { authInitState } from '@/utils'

const state = authInitState()

const actions = {
    async login({ commit }, credentials) {
        // const credentialIsEmail = validEmail(credentials.userNameOrEMail)

        const data = {
            // [credentialIsEmail ? 'email' : 'username']: credentials.userNameOrEMail,
            username: credentials.userNameOrEMail,
            password: credentials.password
        }

        const loginRes = await httpRequest('post', '/token/', data)

        if (loginRes.success) {
            sessionStorage.setItem('auth_token', loginRes.data.access)
            sessionStorage.setItem('auth_token_refresh', loginRes.data.refresh)
            const userDataResponse = await httpAuthRequest('get', 'rest-auth/user/')
            commit(userDataResponse.success ? 'SET_USER' : 'SET_LOGIN_ERROR', userDataResponse.data)
            return userDataResponse.success

        } else commit('SET_LOGIN_ERROR', loginRes.data)

        return false
    },

    async signup({ commit }, credentials) {
        delete credentials.passwordConfirmation

        const response = await httpRequest(
            'post',
            'rest-auth/registration/',
            credentials
        )
        if (!response.success) commit('SET_SIGNUP_ERROR', response.data)
        
        return response
    },

    async emailReset({ commit }, credentials) {
        const response = await httpRequest(
            'post',
            'rest-auth/password/reset/',
            credentials
        )
        if (!response.success) commit('SET_SIGNUP_ERROR', response.data)
        return response.success
    },

    async logout({ commit }) {
        commit('RESET_STATE')
        commit('RESET_PROFILES')
        sessionStorage.removeItem('auth_token')
        await httpAuthRequest('post', 'rest-auth/logout/')
    },

    async updateUserInfo({ commit }, payload) {
        let response = await httpAuthRequest('patch', `userupdate/${payload.pk}/`, payload)
        if (response.success) {
            commit('SET_USER', response.data)
        }
        return response
    },

}

const mutations = {
    SET_USER(state, user) {
        state.user = user
    },
    RESET_STATE(state) {
        Object.assign(state, authInitState())
    }
}

export default {
    state,
    actions,
    mutations
}
